import { AxiosPromise } from "axios";
import { HttpClient } from "../../../shared/api/httpClient";
import { API_ENDPOINT } from "../../../shared/constanst/constants";

const API_SLUG = 'Descargas';

export class DescargasAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

    DatosFacturacionOficial(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosFacturacionOficial`);
	}

	DatosFuncionesSubFuncionesArea(): AxiosPromise<Blob> {
		return this.cliente.getFile(`/DatosFuncionesSubFuncionesArea`);
	}

	DatosCoste(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosCoste`);
	}

	DatosDedicacionHoras(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data,`/DatosDedicacionHoras`);
	}

	DatosFacturacionFinal(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosFacturacionFinal`);
	}

	DatosFacturacionCP(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosFacturacionPorCP`);
	}

	DatosFacturacionUsuario(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosFacturacionPorUsuario`);
	}

	DatosCertificadoDesplazados(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/DatosCertificadoDesplazados`);
	}
}